module.exports = __webpack_public_path__ + "img/goal-02.e248efb0.png";